module.exports = __webpack_public_path__ + "static/media/logo.7e1c4e8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 434
// module chunks = 0